module.exports = __webpack_public_path__ + "static/media/Sound-bowl.bb2d6558.mp3";